<template>
  <article>
    <group gutter="0px" class="status">
      <cell title="客户姓名" :value="clue.customer_name"></cell>
      <cell title="联系电话" :value="clue.mobile"></cell>
    </group>
    <group title="到店信息" class="status">
      <cell title="购车意向" primary="content" class="status-left status-cell">
        <div slot="value" class="status-cell-group">
          <cell v-for="(item,index) in clue.intention_cars" :key="index"
              :title="item.car_model_name+'-'+item.inner_color_ch+'-'+item.outer_color_ch" class="car-intention">
          </cell>
        </div>
      </cell>
      <cell title="竞品车型" primary="content" class="status-left status-cell">
        <div slot="value" class="status-cell-group"><!--最多三个-->
          <cell v-for="(item,index) in clue.contrast_cars" :key="index"
                :title="item.model_name" class="car-intention">
          </cell>
        </div>
      </cell>
      <cell title="线索来源" :value="getFromTypeValue(clue.from_type)"></cell>
      <cell title="客户渠道" :value="getChannelValue(clue.channel_type,clue.sub_channel_type)"></cell>
      <cell title="地区来源" :value="getArea(clue.province,clue.city,clue.district)"></cell>
      <cell title="详细地址" :value="clue.address"></cell>
    </group>
    <group title="跟进记录" v-if="clue.notes.length>0">
      <cell class="sale-record" v-for="(item, index) in clue.notes" :key="index">
        <p slot="after-title" class="content">{{item.remark}}</p>
        <p slot="after-title" class="time">{{item.created_at}}</p>
      </cell>
    </group>
    <section class="btn-bottom">
      <div class="btn-fix">
        <a class="btn" href="javascript:void(0);" @click.stop="createNewCustomerArchives()">新建客户档案</a>
      </div>
    </section>
  </article>
</template>

<script>
import {
  Cell,
  Group
} from '@lx-frontend/cvux'
import cache from '../../../common/cache'

export default {
  components: {
    Cell,
    Group
  },
  data () {
    return {
      id: '',
      localArchivesDataKey: 'customerArchivesLocalData',
      store_visit_id: '',
      arrive_type: [],
      intention_level: [],
      car_color: [],
      from_type: [],
      channelTypeArr: [],
      subChannelTypeArr: [],
      clue: {
        notes: []
      }
    }
  },
  created () {
    this.id = this.$route.params.id
    this.store_visit_id = this.$route.query.store_visit_id
    if (this.id) {
      this.$rest.saleManage.getEnums().then(res => {
        if (res.code === 0) {
          let data = res.data
          this.arrive_type = data.arrive_type
          this.intention_level = data.intention_level
          this.car_color = data.car_color
          this.from_type = data.from_type
          this.channelTypeArr = res.data.channel_type
          this.subChannelTypeArr = res.data.sub_channel_type
        }
      }).then(() => {
        this.$rest.saleManage.clueArchivesDetail(null, this.id).then(res => {
          if (res.code === 0) {
            this.clue = res.data
            this.clue.intention_cars = this.clue.intention_cars.map(v => {
              v.inner_color_ch = this.car_color.find(t => {
                return v.inner_color === parseInt(t.key)
              }).value
              v.outer_color_ch = this.car_color.find(t => {
                return v.outer_color === parseInt(t.key)
              }).value
              return v
            })
            let channelT = this.clue.channel_type
            if (channelT > 0) {
              let subChannelT = this.clue.sub_channel_type
              subChannelT = channelT === 1 ? `100${subChannelT}` : `${channelT}${channelT}`
              this.chanelList = [channelT + '', subChannelT]
            } else {
              this.chanelList = []
            }
          }
        })
      })
    }
  },
  methods: {
    getChanelType (list, subList) {
      let listArr = []
      list.forEach(v => {
        listArr.push({
          name: v.value,
          value: v.key
        })
      })
      list.forEach(v => {
        if (v.value === '网络渠道') {
          subList.forEach(j => {
            listArr.push({
              name: j.value,
              value: `${v.key}00${j.key}`,
              parent: v.key
            })
          })
          listArr.push({
            name: '--',
            value: `${v.key}000`,
            parent: v.key
          })
        } else {
          listArr.push({
            name: '--',
            value: v.key + v.key,
            parent: v.key
          })
        }
      })
      return listArr
    },
    getFromTypeValue (fromType) {
      if (!fromType) return ''
      let item = this.from_type.find(v => {
        return parseInt(v.key) === fromType
      })
      if (item) {
        return item.value
      }
    },
    getChannelValue (channelType, subChannelType) {
      if (!channelType) return ''
      let str = ''
      let channel = this.channelTypeArr.find(v => {
        return parseInt(v.key) === channelType
      })
      if (channel) {
        str = channel.value
      }
      let subChannel = this.subChannelTypeArr.find(t => {
        return parseInt(t.key) === subChannelType
      })
      if (subChannel) {
        str += '-' + subChannel.value
      }
      return str
    },
    getArea (province, city, district) {
      if (!province || !city) return ''
      let str = province + '-' + city
      if (district) {
        str += '-' + district
      }
      return str
    },
    createNewCustomerArchives () {
      if (this.id) {
        let localData = cache.getSessionData(this.localArchivesDataKey)
        let clue = this.clue
        localData.customer.address = clue.address
        localData.customer.intention_cars = clue.intention_cars
        localData.customer.contrast_cars = clue.contrast_cars.map(v => {
          return {
            car_model_id: v.model_id,
            car_model_name: v.model_name
          }
        })
        localData.customer.intention_level = '5'
        localData.customer.mobile = clue.mobile
        localData.customer.first_arrive_type = clue.from_type + ''
        localData.customer.customer_name = clue.customer_name
        if (clue.province_code && clue.city_code && clue.district_code) {
          localData.addressList = [clue.province_code, clue.city_code, clue.district_code]
        }
        let chanelList = []
        if (clue.channel_type > 0) {
          let channelT = clue.channel_type + ''
          let subChannelT = clue.sub_channel_type + ''
          subChannelT = channelT === '1' ? `100${subChannelT}` : `${channelT}${channelT}`
          chanelList = [channelT, subChannelT]
        }
        localData.chanelList = chanelList
        cache.setSessionData(this.localArchivesDataKey, localData)
        this.$router.push({ path: '/salemanage/staff/customerarchives', query: { store_visit_id: this.store_visit_id } })
      }
    }
  }
}
</script>
<style lang="less">
   @import "../../../stylesheets/modules/salemanage/sale";
</style>
